import { Route } from '@angular/router';
import { authGuard } from './core/guards/auth.guard';
import { devOnlyGuard } from './core/guards/dev-only.guard';
import { publicGuard } from './core/guards/public.guard';
import { onboardingGuard } from './features/onboarding/guards/onboarding.guard';
import { ownerOnlyGuard } from './core/guards/owner-only.guard';

export const appRoutes: Route[] = [
  // ── Public routes (auth) ──────────────────────
  {
    path: 'auth',
    loadChildren: () =>
      import('./features/auth/auth.routes').then((m) => m.AUTH_ROUTES),
    canActivate: [publicGuard],
  },

  // ── Public: Circle invitation acceptance ──────
  {
    path: 'invite/:token',
    loadComponent: () =>
      import('./features/circle/pages/accept-invitation/accept-invitation').then(
        (m) => m.AcceptInvitationPage
      ),
    title: 'ROUTE_TITLES.ACCEPT_INVITATION',
  },

  // ── Onboarding (post-register, one-time) ──────
  {
    path: 'onboarding',
    loadChildren: () =>
      import('./features/onboarding/onboarding.routes').then(
        (m) => m.ONBOARDING_ROUTES
      ),
    canActivate: [authGuard],
  },

  // ── Authenticated routes (App Shell) ──────────
  {
    path: '',
    loadComponent: () =>
      import('./core/layouts/app-shell/app-shell').then((m) => m.AppShell),
    canActivate: [onboardingGuard],
    children: [
      {
        path: 'home',
        loadChildren: () =>
          import('./features/home/home.routes').then((m) => m.HOME_ROUTES),
      },
      {
        path: 'timeline',
        loadChildren: () =>
          import('./features/timeline/timeline.routes').then(
            (m) => m.TIMELINE_ROUTES
          ),
      },
      {
        path: 'memory',
        loadChildren: () =>
          import('./features/memory/memory.routes').then(
            (m) => m.MEMORY_ROUTES
          ),
      },
      {
        path: 'circle',
        loadChildren: () =>
          import('./features/circle/circle.routes').then(
            (m) => m.CIRCLE_ROUTES
          ),
        canActivate: [ownerOnlyGuard],
      },
      {
        path: 'vault',
        loadChildren: () =>
          import('./features/vault/vault.routes').then(
            (m) => m.VAULT_ROUTES
          ),
        canActivate: [ownerOnlyGuard],
      },
      {
        path: 'settings',
        loadChildren: () =>
          import('./features/settings/settings.routes').then(
            (m) => m.SETTINGS_ROUTES
          ),
      },
      {
        path: '',
        redirectTo: 'home',
        pathMatch: 'full',
      },
    ],
  },

  // ── Demo (dev only) ──────────────────────────
  {
    path: 'demo',
    loadChildren: () =>
      import('./features/demo/demo.routes').then((m) => m.DEMO_ROUTES),
    canActivate: [devOnlyGuard],
  },

  // ── Fallback ──────────────────────────────────
  {
    path: '**',
    loadComponent: () =>
      import('./features/not-found/not-found').then((m) => m.NotFoundPage),
    title: 'ROUTE_TITLES.NOT_FOUND',
  },
];
